import React from 'react';
import {ProspectPool, ProspectPoolScore, ProspectScoreSetting} from 'api';
import {Select, Date, Number, Text} from './Custom';

interface CustomScoreItemsProps {
  prospectPool: ProspectPool;
  prospectScore: ProspectPoolScore;
  prospectScoreSetting: ProspectScoreSetting;
}

const CustomScoreItems: React.FC<CustomScoreItemsProps> = ({
  prospectPool,
  prospectScore,
  prospectScoreSetting,
}) => {
  return (
    <>
      {prospectScoreSetting?.clientProspectScoreSettingCustomizeItems?.map(
        (settingItem) => {
          const customizeItem = settingItem?.poolProspectCustomizeItem;
          const commonProps = {
            key: customizeItem.id,
            prospectPool,
            prospectScore,
            settingItem,
          };

          switch (customizeItem.dataType) {
            case 'select':
              return <Select {...commonProps} />;
            case 'date':
              return <Date {...commonProps} />;
            case 'number':
              return <Number {...commonProps} />;
            case 'text':
              return <Text {...commonProps} />;
            default:
              return null;
          }
        },
      )}
    </>
  );
};

export default CustomScoreItems;
